import axios from "axios";
import { get_employee_permission, update_roles_and_permission } from "../../../Redux/Settings/Roles and permission/viewRolesAndPermissionSlice";
import store from "../../../Redux/store";
import { HEADERS } from "../../UrlAndPaths";
import { setSubmitLoading } from "../../../Redux/Dashboard/mainDashBoardSlice";

// Add Roles and Permission by employee id
export const addEmployeeRolesAndPermissionAPICall = async (
  body,
  setState,
  state
) => {
  store.dispatch(setSubmitLoading(true))
  await axios
  .post("settings/addsettings", body, HEADERS)
  .then((res) => {
    if (res.status === 200) {
        setState({...state,message:"Permission Updated",success:true})
        store.dispatch(setSubmitLoading(false))
        // Only reload permissions if the logged-in user is the one being updated
        const loggedInUserId = store.getState().loginSlice?.value?._id;
        if (loggedInUserId && body.empId === loggedInUserId) {
          employeeRolesAndPermission({ _id: body.empId });
        }
      }
    })
    .catch((err) => {
      setState({...state,message:"Something went wrong !!",error:true})
      store.dispatch(setSubmitLoading(false))
     
    });
};

//Get roles and permission of an employee or by designation
export const getRolesAndPermissionAPICall = async (body) => {
  try {
    const res = await axios.post("settings/viewuserpermission", body, HEADERS);

    if (res.status === 200) {
      console.log("Roles & Permissions Data:", res.data);
      store.dispatch(
        update_roles_and_permission({ rolesAndPermission: res.data })
      );
    }
  } catch (err) {
    console.error("Error fetching roles and permissions:", err?.response || err);
    store.dispatch(
      update_roles_and_permission({ rolesAndPermission: undefined })
    );
  }
};
// get employee roles and permission
export const employeeRolesAndPermission=(body)=>{
  store.dispatch(setSubmitLoading(true))
  axios.post("employee/viewemployeepermissions",body,HEADERS)
  .then((res)=>{
    if(res.status===200){
      console.log(res.data);
      
      store.dispatch(setSubmitLoading(false))
      store.dispatch(get_employee_permission({employeePermissionData:res.data}))
      localStorage.setItem("userpermission",JSON.stringify(res.data))
    }
  })
  .catch((err)=>{
    store.dispatch(setSubmitLoading(false))
    store.dispatch(get_employee_permission({employeePermissionData:undefined}))

  })
}